import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

import styles from "./listMenu.module.scss";

type TListMenuItemProps = {
    name: string,
    icon: IconProp,
    onClick?: () => void
}

export const ListMenuItem: FC<TListMenuItemProps> = ({name, icon, onClick}: TListMenuItemProps) => {
    return (
        <div onClick={onClick} className={styles.listMenuItem}>
            <FontAwesomeIcon icon={icon} />
            <span>{name}</span>
        </div>
    );
}